/**
 * Funcionalidades da viagem que quem administra pode desligar.
 *
 * Tudo nasce LIGADO (decisão do PO): desligar é a ação, e ela gera aviso
 * para o grupo. O mapa guardado na viagem só tem as chaves desligadas.
 */
export const TRIP_FEATURES = [
  'bagagem',
  'ranking',
  'enquetes',
  'ponto_de_encontro',
  'carro',
  'aniversarios',
  'carimbos',
  'resumo_do_dia',
] as const;

export type TripFeature = (typeof TRIP_FEATURES)[number];

export const TRIP_FEATURE_LABELS: Record<TripFeature, { nome: string; descricao: string }> = {
  bagagem: { nome: 'Bagagem', descricao: 'Listas do que levar — sua, da família e da viagem.' },
  ranking: { nome: 'Ranking da viagem', descricao: 'Quem mais gastou, títulos e medalhas — o total de cada pessoa, visível para o grupo.' },
  enquetes: { nome: 'Enquetes', descricao: '"Onde vamos jantar?" — o grupo vota e a vencedora vira atividade.' },
  ponto_de_encontro: { nome: 'Ponto de encontro e avisos', descricao: 'Marcar onde e quando se encontrar; "saímos em 20 min".' },
  carro: { nome: 'Cadê o carro?', descricao: 'Guardar onde estacionou, com foto da fileira.' },
  aniversarios: { nome: 'Aniversários', descricao: 'Avisar o grupo quando alguém faz aniversário na viagem.' },
  carimbos: { nome: 'Carimbos', descricao: 'Um carimbo por lugar visitado — o passaporte de cada pessoa.' },
  resumo_do_dia: { nome: 'Resumo do dia', descricao: 'À noite, o card do dia: o que foi feito, fotos, gasto do grupo, carimbos. Avisa o grupo quando fica pronto.' },
};

export function isTripFeature(v: unknown): v is TripFeature {
  return typeof v === 'string' && (TRIP_FEATURES as readonly string[]).includes(v);
}

/** Ligada, a menos que esteja explicitamente desligada. */
export function featureEnabled(features: Record<string, boolean> | null | undefined, f: TripFeature): boolean {
  return features?.[f] !== false;
}
